var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmbRow',[_c('div',{class:[
      'd-flex',
      { 'justify-content-center': _vm.isAlignedCenter },
      { 'justify-content-end': _vm.isAlignedRight },
    ]},[_c('GmbCopyright')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }